export default __webpack_public_path__ + "static/media/vignetteStrollMarly.3c3c125f.jpg";